<div class="w-100 text-end mt-3" *ngIf="blogCategoryForm.value.blog.length>0">
    <a class="cpr btn btn-primary"
        (click)="showSortModal(blogCategoryForm.value.blog, 'blog_category')">
        <i class="fa fa-sort" aria-hidden="true"></i> Change Position</a>
</div>

<div class="container">
    <form [formGroup]="blogCategoryForm"
        (ngSubmit)="onSubmit(blogCategoryForm)">
        <div class="row">
            <div class="col-md-4 mt-2" formArrayName="blog"
                *ngFor="let item of blogCategory().controls; let i = index;">

                <div class="border shadow bg-white p-4 mt-2"
                    [formGroupName]="i">
                    <a *ngIf="blogCategory().controls.length>1"
                        href="javascript:void(0)" class="ms-2 close-btn"
                        (click)="removeCategory(i)"><i
                            class="uil-times fa-2x"></i></a>

                    <div class="my-2 row">
                        <div class="col-md-12">
                            <label class="col-form-label">Category</label>
                            <input type="text" class="form-control"
                                placeholder="Category"
                                formControlName="blog_category"
                                (change)="dataChanged(i)"
                                [ngClass]="{'invalid': item.get('blog_category').invalid && isSubmitted}">
                        </div>
                    </div>
                    <!-- <div class="my-2 row">
                        <div class="col-md-12">
                            <label class="col-form-label">Description</label>
                            <ckeditor [editor]="Editor"
                                formControlName="description"
                                (change)="dataChanged(i)"
                                [ngClass]="{'invalid': item.get('description').invalid && isSubmitted}"
                                data="<p>Content of the editor.</p>"></ckeditor>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-md-4 p-5">
                <div class="row">
                    <button
                        *ngIf="checkPermission('content_management_home_create')"
                        class="btn btn-primary mt-1 me-1 col-md-12"
                        type="button" (click)="addCategory()"><i
                            class="uil-plus"></i> Add</button>
                    <button
                        *ngIf="checkPermission('content_management_home_create')&&checkPermission('content_management_home_edit')"
                        class="btn btn-info mt-1 col-md-12" type="submit"><i
                            [ngClass]="{'fa fa-pulse fa-spin fa-spinner': isUpdating,'bx bx-save': !isUpdating}"></i>
                        Save All</button>
                    <!-- <app-publish-btn *ngIf="checkPermission('content_management_home_publish')"
                        class="col-md-12 pt-1 px-0" [publish]="'UspFeature'" [page]="'home'"></app-publish-btn> -->
                </div>
            </div>
        </div>
    </form>
</div>